import { useCallback, useEffect, useState } from "react";
import { TextField, DateField, ReferenceField } from "react-admin";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import UpdateDateDialog from "./UpdateDateDialog";
import { Grid, Typography, Box, Paper } from "@mui/material";
import { studentRequests } from "api/studentApi";

const ThesisDefenseInfo = ({ internshipSessionId }) => {
  const [thesisDefenseInfo, setThesisDefenseInfo] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const fetchThesisDefenseInfo = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        graduationRequests.thesisDefenseSessionDate(internshipSessionId),
      );
      setThesisDefenseInfo(data);
    } catch (err) {
      console.error(err);
      setThesisDefenseInfo(null);
    } finally {
      setLoaded(true);
    }
  }, [internshipSessionId]);

  useEffect(() => {
    if (!internshipSessionId) return;
    fetchThesisDefenseInfo();
  }, [internshipSessionId, fetchThesisDefenseInfo]);

  if (!loaded) return null;

  if (!thesisDefenseInfo) {
    return (
      <Paper sx={{ p: 2, m: 2 }}>
        <UpdateDateDialog
          internshipSessionId={internshipSessionId}
          defenseDate={null}
          fetchThesisDefenseInfo={fetchThesisDefenseInfo}
        />
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2, m: 2 }}>
      <Typography
        color="secondary"
        sx={{ fontWeight: 600, mt: 2, mb: 4, textAlign: "center" }}
      >
        Информация за защита на дипломна работа
      </Typography>

      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <Box>
            <Typography
              variant="caption"
              color="info"
              sx={{ fontWeight: 600 }}
            >
              Академична година
            </Typography>
            <Box sx={{ mt: 0.5 }}>
              <ReferenceField
                record={thesisDefenseInfo}
                source="academicYearId"
                reference={studentRequests.getAcademicYearsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Box>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Box>
            <Typography
              variant="caption"
              color="info"
              sx={{ fontWeight: 600 }}
            >
              Тип на сесията
            </Typography>
            <Box sx={{ mt: 0.5 }}>
              <TextField
                record={thesisDefenseInfo}
                source="typeText"
              />
            </Box>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <Box>
            <Typography
              variant="caption"
              color="info"
              sx={{ fontWeight: 600 }}
            >
              Дата на защита
            </Typography>
            <Box sx={{ mt: 0.5 }}>
              <DateField
                record={thesisDefenseInfo}
                source="defenseDate"
                locales="bg-BG"
              />
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <UpdateDateDialog
            internshipSessionId={internshipSessionId}
            defenseDate={thesisDefenseInfo?.defenseDate}
            fetchThesisDefenseInfo={fetchThesisDefenseInfo}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ThesisDefenseInfo;
